import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { ReferenceBitSummary } from '../../../shared/interfaces/request';
import { map, Observable } from 'rxjs';
import { CoGs } from '../../interfaces/rta';
import { RequestState } from '../../store/state/request.state';
import { RequestActions } from '../../store/action/request.action';

@Component({
    selector: 'estimated-cogs',
    templateUrl: './estimated-cogs.component.html',
    styleUrls: ['./estimated-cogs.component.css'],
    standalone: false
})
export class EstimatedCogsComponent implements OnInit {
  
  @Input() draftId: number = 0;

  public cogs$: Observable<CoGs>;
  constructor(private store: Store) {
    this.cogs$ = this.store.select(RequestState.getCoGs).pipe(
      map(cogs => cogs || { 
        RtaNumber: this.draftId,
    ReferenceMaterialNumber: '',
    Ref_PrimaryCutter: '',
    Ref_BackupElement: '',
    Ref_OverallLeach: '',
    Ref_Powder: '',
    Ref_Binder: '',
    Ref_Hardfacing: '',
    Ref_Uppersection: '',
    Ref_OnePiece: false,
    Rta_PrimaryCutter: '',
    Rta_BackupElement: '',
    Rta_OverallLeach: '',
    Rta_Powder: '',
    Rta_Binder: '',
    Rta_Hardfacing: '',
    Rta_Uppersection: '',
    Rta_OnePiece: false,
    Delta_Matrix2Steel: '',
    Total_Cost: '',
    Total_Savings: '',
    HideReference: false,
    Justification: '',
      })
    );
   }
  public ReferenceCoGs: any;
  

  ngOnInit(): void {
  }
  getCogsDeltaColor(rtaCog:any, refCog:any){
    if(parseFloat(rtaCog)>parseFloat(refCog))
      return 'cogsNegative';
    else if(parseFloat(refCog)>parseFloat(rtaCog))
      return 'cogsSavings';
    return 'cogsNeutral';
  }
  getTotalSavingsClass(cost:any){
    if(parseFloat(cost) > 0)
      return 'cogsSavings';
    else
      return 'cogsNegative';
  }
  getCogDelta(rtaCog:any, refCog:any)
  {
    if(rtaCog>refCog)
      {
        let cogDelta = rtaCog-refCog;
        return '$'+ cogDelta.toFixed(2);
      }
    else if(refCog>rtaCog)
      {
        let cogDelta = rtaCog-refCog;
        return '-$'+ cogDelta.toFixed(2);
      }
    else
        return '$0'
  }

  /**
   * Formats a raw value to a string with specified decimal places.
   * Returns '0.00' for null/undefined/NaN values.
   */
  formatTo(raw: any, decimals = 2): string {
    if (raw == null || raw === '') {
      return (0).toFixed(decimals);
    }
    const n = typeof raw === 'number' ? raw : parseFloat(raw);
    if (isNaN(n)) {
      return (0).toFixed(decimals);
    }
    return n.toFixed(decimals);
  }
}
